"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfessionalOutput = instanceOfProfessionalOutput;
exports.ProfessionalOutputFromJSON = ProfessionalOutputFromJSON;
exports.ProfessionalOutputFromJSONTyped = ProfessionalOutputFromJSONTyped;
exports.ProfessionalOutputToJSON = ProfessionalOutputToJSON;
var Professional_1 = require("./Professional");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the ProfessionalOutput interface.
 */
function instanceOfProfessionalOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ProfessionalOutputFromJSON(json) {
    return ProfessionalOutputFromJSONTyped(json, false);
}
function ProfessionalOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Professional_1.ProfessionalFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ProfessionalOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Professional_1.ProfessionalToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
